import { getEnvBoolean } from './runtimeEnv';

export let debugMode = getEnvBoolean('VUE_APP_DEBUG_MODE', false);

console.log('Debug mode is :', debugMode);
export function setDebugMode(value) {
  debugMode = !!value;
  console.log('Debug mode set to:', debugMode);
}
